var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { IconChecked, IconClosePill, IconDropdown } from "@wrstudios/icons";
import React, { forwardRef, useState } from "react";
import Select from "react-windowed-select";
import { Container } from "./styled/select";
export default forwardRef(function (_a, ref) {
    var _b = _a.app, app = _b === void 0 ? "suite" : _b, components = _a.components, classNamePrefix = _a.classNamePrefix, closeMenuOnSelect = _a.closeMenuOnSelect, isMulti = _a.isMulti, onChange = _a.onChange, value = _a.value, props = __rest(_a, ["app", "components", "classNamePrefix", "closeMenuOnSelect", "isMulti", "onChange", "value"]);
    var _c = useState(value || []), selectedOptions = _c[0], setSelectedOptions = _c[1];
    return (React.createElement(Container, { app: app, hasSelectedOptions: Array.isArray(selectedOptions) && !!selectedOptions.length },
        React.createElement(Select, __assign({ ref: ref, styles: {
                menuList: function (base) { return (__assign(__assign({}, base), { paddingTop: 8, paddingBottom: 8 })); }
            }, placeholder: isMulti ? "Choose all that apply" : "Select one", isMulti: isMulti }, props, { value: value, onChange: function (options) {
                setSelectedOptions(options);
                onChange && onChange(options);
            }, classNamePrefix: "dropdown", closeMenuOnSelect: typeof closeMenuOnSelect === "undefined"
                ? !isMulti
                : closeMenuOnSelect, components: {
                Option: function (_a) {
                    var children = _a.children, className = _a.className, cx = _a.cx, isDisabled = _a.isDisabled, isFocused = _a.isFocused, isSelected = _a.isSelected, innerRef = _a.innerRef, innerProps = _a.innerProps;
                    return (React.createElement("div", __assign({ ref: innerRef, className: cx({
                            option: true,
                            "option--is-disabled": isDisabled,
                            "option--is-focused": isFocused,
                            "option--is-selected": isSelected
                        }, className) }, innerProps),
                        children,
                        isSelected && (React.createElement("div", { className: "dropdown__icon dropdown__icon--selected" },
                            React.createElement(IconChecked, null)))));
                },
                MultiValueRemove: function (_a) {
                    var innerProps = _a.innerProps;
                    return (React.createElement("div", __assign({}, innerProps, { className: "dropdown__icon dropdown__icon--remove" }),
                        React.createElement(IconClosePill, null)));
                },
                DropdownIndicator: function () { return (React.createElement("div", { className: "dropdown__icon dropdown__icon--indicator" },
                    React.createElement(IconDropdown, null))); },
                ClearIndicator: function (_a) {
                    var innerProps = _a.innerProps;
                    return (React.createElement("div", __assign({}, innerProps, { className: "dropdown__icon dropdown__icon--clear-indicator", title: "Clear " + (isMulti ? "choices" : "choice") }),
                        React.createElement(IconClosePill, null)));
                }
            } }))));
});
